import type { CheckedState } from '@radix-ui/react-checkbox'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Render } from '@/components/render-if'
import { Checkbox, Label } from '@/components/ui'
import { TextareaField } from '@/components/ui/textarea'
import { TermosDaProposta } from '@/features/proposta/components/termos-da-proposta'
import { CardEtapaContent, CardEtapaItem } from '@/features/proposta/components/ui/card-etapa'
import type { TDetalhesPropostaSchema } from '@/features/proposta/schemas/detalhes-proposta-schema'
import { showToast } from '@/infra/sonner'

type TTermosDapropostaProps = {
  assinaturaContrato?: string
  termosDaProposta: string
}
export const TermosObservacoesDaPropostaStep = ({ assinaturaContrato, termosDaProposta }: TTermosDapropostaProps) => {
  const { t } = useTranslation('proposta')
  const { control, watch, setValue } = useFormContext<TDetalhesPropostaSchema>()

  const handleConfirmarTermos = (value: CheckedState) => {
    if (!assinaturaContrato) {
      showToast({
        message: t('detalhes_proposta.termos_observacoes.termos.erro_assinatura'),
        variant: 'error',
        closeButton: true,
      })
      return
    }

    setValue(
      'detalhesDaProposta.termosDaProposta',
      value ? `${t(termosDaProposta, { defaultValue: termosDaProposta, assinaturaContrato })}` : '',
    )
  }

  return (
    <CardEtapaItem
      titulo={t('detalhes_proposta.termos_observacoes.titulo')}
      descricao={t('detalhes_proposta.termos_observacoes.descricao')}
      completed={Boolean(watch(`detalhesDaProposta.termosDaProposta`))}
    >
      <CardEtapaContent className="gap-6">
        <span className="form-label">{t('detalhes_proposta.termos_observacoes.termos.titulo')}</span>
        <Render.If condition={termosDaProposta}>
          {(termos) => <TermosDaProposta termos={termos} assinaturaContrato={assinaturaContrato ?? '-'} />}
        </Render.If>
        <div className="mb-2 flex items-center gap-2">
          <Checkbox
            id="termosDaProposta"
            checked={Boolean(watch('detalhesDaProposta.termosDaProposta'))}
            onCheckedChange={handleConfirmarTermos}
          />
          <Label htmlFor="termosDaProposta" className="text-base leading-6 font-normal sm:text-sm">
            {t('detalhes_proposta.termos_observacoes.termos.label')}
          </Label>
        </div>
        <TextareaField
          control={control}
          className="p-6"
          maxLength={3_000}
          name="detalhesDaProposta.observacoes"
          label={t('detalhes_proposta.termos_observacoes.observacoes.label')}
          placeholder={t('detalhes_proposta.termos_observacoes.observacoes.placeholder')}
        />
      </CardEtapaContent>
    </CardEtapaItem>
  )
}
